import { SpaceDashboardRounded } from '@mui/icons-material';
import {
    Avatar,
    Box,
    Card,
    Divider,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Stack,
    Typography,
} from '@mui/material';
import { Link } from '@tanstack/react-router';
import { maxToneToLevel } from '@utils/colorUtils';

interface EmailListProps {
    data: any[];
    action?: React.ReactNode | ((item: any) => React.ReactNode);
    metaText?: (item: any) => string;
    secondaryPath?: string;
}

const EmailItem = ({ item, action, metaText, secondaryPath }) => {
    return (
        <ListItemButton
            LinkComponent={Link}
            to={item.id}
            sx={{
                height: 80 + 24,
                paddingY: 1.5,
                paddingX: 2,
                borderRadius: 0,
            }}
        >
            <ListItemAvatar
                sx={{
                    width: 80,
                    height: 80,
                    borderRadius: theme => theme.shape.lg,
                    overflow: 'hidden',
                    mr: 2,
                }}
            >
                <Avatar
                    sx={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: maxToneToLevel(
                            item.background_color,
                            94,
                        ),
                        borderRadius: 'inherit',
                    }}
                    src={item.thumbnail}
                >
                    <SpaceDashboardRounded sx={{ fontSize: 60 }} />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={item.subject}
                primaryTypographyProps={{
                    variant: 'titleLarge',
                    noWrap: true,
                    mr: 1,
                }}
                secondary={
                    <>
                        <Box>
                            <Typography
                                variant="bodyMedium"
                                noWrap
                                gutterBottom
                            >
                                {item[secondaryPath]}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography
                                variant="bodyMedium"
                                color="onSurfaceVariant.main"
                                sx={{ alignSelf: 'flex-end' }}
                            >
                                {metaText?.(item)}
                            </Typography>
                        </Box>
                    </>
                }
                secondaryTypographyProps={{
                    component: Box,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flex: 1,
                }}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    py: 0.75,
                }}
            />
            <Box alignSelf="flex-start">{action?.(item)}</Box>
        </ListItemButton>
    );
};

const EmailList: React.FC<EmailListProps> = ({
    data,
    action,
    metaText,
    secondaryPath,
}) => {
    return (
        <Card>
            <Stack divider={<Divider />}>
                {data.map((item, index) => (
                    <EmailItem
                        key={index}
                        item={item}
                        action={action}
                        metaText={metaText}
                        secondaryPath={secondaryPath}
                    />
                ))}
            </Stack>
        </Card>
    );
};

export default EmailList;
